
<template>
  <v-autocomplete 
    v-model="object_with_model[model]"
    :label="custom_label ? custom_label : `Selecione o módulo`" 
    :items="modalities"
    :rules="required" 
    :prepend-icon="outlined ? undefined : 'mdi-star'" 
    :prepend-inner-icon="outlined ? 'mdi-store' : undefined" 
    :outlined="outlined"
    :dense="dense"
    :hide-details="outlined ? 'auto' : undefined"
    item-text="name" 
    item-value="id" 
    :loading="loading"
    :chips="multiple" 
    :multiple="multiple"
    :readonly="readonly"
    @change="emitObject"
  ></v-autocomplete>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import validations from '@/mixins/validations'
import Api from '@/api/index';

export default {
  name: 'SelectModality',
  mixins: [ validations ],

  props: {
    solution: {
      type: Array,
      default: ()=>['retail', 'wholesale']
    },
    object_with_model: {
      type: Object,
      default: {}
    },
    custom_label: {
      type: String,
      default: null
    },
    model:{
      type: String,
      default: 'place_id'
    },
    multiple: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    index_by_current_user: {
      type: Boolean,
      default: true
    },
    outlined: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    },
    preselect_active: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      modalities: [],
      loading: false,
    }
  }, 
  methods: {
    emitObject(id){
      this.$emit('selectedModality', this.modalities.find(el=>el.id == id))
    },
    getModalities() {
      this.loading = true
      let filter = {
        solution: [...this.solution],
      }
      if(this.index_by_current_user) filter.index_by_current_user = this.index_by_current_user

      Api.Modality.index(filter).then(r=> {
        this.modalities = r.data.sort((a, b)=> {
          if(a.solution == 'wholesale'){
            return -1;
          }
        })
      }).catch(err=>{
        console.log(err)
      }).finally(()=>{
        this.loading = false
        this.applyActivePreselection()
        if(this.object_with_model[this.model] != null){
          this.emitObject(this.object_with_model[this.model])
        }
      })
    },
    applyActivePreselection() {
      if (!this.preselect_active || this.multiple || this.current_value) return
      const active_id = parseInt(this.active_modality_id)
      let target = active_id > 0 ? this.modalities.find(el => el.id == active_id) : null
      if (!target && this.modalities.length === 1) target = this.modalities[0]
      if (target) this.$set(this.object_with_model, this.model, target.id)
    },
  },
  computed: {
    ...mapState({
      current_user_id: state=> state.User.oneUser.data.attributes.id,
      active_modality_id: state => state.App.activeModalityId,
    }),
    current_value() {
      return this.object_with_model[this.model]
    },
  },
  watch: {
    current_value(nv) {
      if (nv == null && !this.loading && this.modalities.length) {
        this.applyActivePreselection()
        if (this.current_value != null) this.emitObject(this.current_value)
      }
    },
    active_modality_id() {
      if (this.current_value != null || this.loading || !this.modalities.length) return
      this.applyActivePreselection()
      if (this.current_value != null) this.emitObject(this.current_value)
    },
  },
  mounted () {
    this.getModalities();
  },
}
</script>